import {
    INFLUENCER_CURATION_PLACES,
    SOCIAL_PLATFORM_DETAILS,
} from '../constants/influencer';

export const renderUserToSocialPlatform = (social_platform: any) => {
    const url = `${SOCIAL_PLATFORM_DETAILS[social_platform.platform].link}${
        social_platform.handle
    }`;
    window.open(url, '_blank');
};

export const showInfluencerModule = (placeId: string) => {
    return INFLUENCER_CURATION_PLACES.includes(placeId);
};
